// ======================================================================
// File Name       : SentMessageSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomButton from '../button/CustomButton';

class SentMessageSearch extends React.Component {
  render() {
    const { onSearchBtnClick, recordNum, getStartEndData, invalid } = this.props;
    return (
      <div>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                スレッドタイトル
              </Col>
              <Col sm={8}>
                <RenderField type="text" name="messageTitle" label="スレッドタイトル" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                送信日時
              </Col>
              <Col className="padding-left-right-clear" sm={8}>
                <Col sm={5}>
                  <RenderField
                    type="datetime"
                    name="sentDateFrom"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                  />
                </Col>
                <Col sm={2} className="text-center" as={Form.Label}>
                  ～
                </Col>
                <Col sm={5}>
                  <RenderField
                    type="datetime"
                    name="sentDateTo"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                  />
                </Col>
                <Col sm={12}>
                  <RenderField
                    name="dateTimeMinMax"
                    type="dateTimeMinMax"
                    validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                    keyDateFrom={'sentDateFrom'}
                    keyDateTo={'sentDateTo'}
                  />
                </Col>
              </Col>
            </Form.Group>
          </Col>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="padding-left-right-clear">
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default SentMessageSearch;
